// extracted by mini-css-extract-plugin
export default {"columnSpace":"ProjectTitle_columnSpace__Q8NDK"};